import { useEffect } from "react";

const Pretix = ({ eventId }: { eventId: string }) => {
  const baseUrl = "https://tickets.otterdam.org/otterdam/";
  const eventUrl = `${baseUrl}${eventId}/`;

  useEffect(() => {
    // Load the CSS file
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = `${eventUrl}widget/v1.css`;
    link.crossOrigin = "anonymous";
    document.head.appendChild(link);

    // Load the JavaScript file
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://pretix.eu/widget/v1.en.js";
    script.async = true;
    script.crossOrigin = "anonymous";
    document.body.appendChild(script);

    // Cleanup function to remove the script and link when the component unmounts
    return () => {
      document.head.removeChild(link);
      document.body.removeChild(script);
    };
  }, [baseUrl, eventUrl]);

  return (
    <div>
      {/* @ts-expect-error Custom JS is used */}
      <pretix-widget event={eventUrl}></pretix-widget>
      <noscript>
        <div className="pretix-widget">
          <div className="pretix-widget-info-message">
            JavaScript is disabled in your browser. To access our ticket shop
            without JavaScript, please
            <a target="_blank" href={eventUrl} rel="noreferrer">
              click here.
            </a>
          </div>
        </div>
      </noscript>
    </div>
  );
};

export default Pretix;
